import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
	InputSignal,
	linkedSignal,
	Signal,
	WritableSignal,
} from '@angular/core'
import { UseLocales } from '@modules/lang-module/decorators/use-locales'
import { TranslatePipe } from '@ngx-translate/core'
import ru from './core/locale/ru.json'
import en from './core/locale/en.json'
import { RecommendationsInterface } from '@modules/twelve-data-module/interfaces/recommendations.interface'
import { TuiSkeleton } from '@taiga-ui/kit'
import { DefaultAnalystsForecast } from '@shared/components/trading/info/info-stocks/common/info-stocks-analytics/common/analysts-forecast/core/consts/default-analysts-forecast'
import { AnalystsForecastItemInterface } from '@shared/components/trading/info/info-stocks/common/info-stocks-analytics/common/analysts-forecast/core/interfaces/analysts-forecast-item.interface'
import { LiveTickerInterface } from '@modules/stocks-module/live-ticker/interfaces/live-ticker.interface'

@UseLocales({ ru, en })
@Component({
	selector: 'app-analysts-forecast',
	templateUrl: './analysts-forecast.component.html',
	styleUrl: './analysts-forecast.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
	imports: [TranslatePipe, TuiSkeleton],
})
export class AnalystsForecastComponent {
	protected readonly math: Math = Math
	protected readonly defaultAnalystsForecast: AnalystsForecastItemInterface[] = DefaultAnalystsForecast

	public recommendations: InputSignal<RecommendationsInterface | null> = input<RecommendationsInterface | null>(null)
	public isLoadingRecommendations: InputSignal<boolean> = input<boolean>(false)
	public liveTicker: InputSignal<LiveTickerInterface | null> = input<LiveTickerInterface | null>(null)
	public totalAnalysts: InputSignal<number> = input<number>(0)

	protected analystsForecast: WritableSignal<AnalystsForecastItemInterface[]> = linkedSignal<
		RecommendationsInterface | null,
		AnalystsForecastItemInterface[]
	>({
		source: this.recommendations,
		computation: (recommendations: RecommendationsInterface | null): AnalystsForecastItemInterface[] => {
			if (!recommendations) return this.defaultAnalystsForecast
			return this.defaultAnalystsForecast.map(
				(item: AnalystsForecastItemInterface): AnalystsForecastItemInterface => {
					const value: number | null = recommendations.trends?.current_month[item.key] ?? null
					return {
						...item,
						value: value || 0,
						percent: value ? this.math.round((value / this.totalAnalysts()) * 100) : 0,
					}
				},
			)
		},
	})

	protected leader: Signal<AnalystsForecastItemInterface> = computed<AnalystsForecastItemInterface>(
		(): AnalystsForecastItemInterface => {
			return this.analystsForecast().reduce(
				(
					leader: AnalystsForecastItemInterface,
					item: AnalystsForecastItemInterface,
				): AnalystsForecastItemInterface => (item.value >= leader.value ? item : leader),
			)
		},
	)
}
